import {
  EnvironmentProviders,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import { ApplicationStore, getModuleGroupByName, SOFTLINE_FEATURE_APPLICATIONS } from '@softline/application';
import { Store } from '@softline/core';
import { SOFTLINE_FEATURE_TRANSLATION, TranslationStore } from '@softline/ui-core';
import {
  provideSoftAppsModule,
  withLazySoftAppsModuleTranslation,
  withSoftAppsModuleInfo,
  withSoftAppsModuleRoutes,
} from '@softapps/core';
import { default as de } from '../i18n/de.json';
import { default as deTitles } from '../i18n/de.titles.json';
import { SOFTLINE_PERMISSION_INVENTUR } from './inventur.shared';
import { inventurRoutes } from './inventur.routes';

export const inventurProviders: (Provider | EnvironmentProviders)[] = [
  provideEnvironmentInitializer(() => {
    const store = inject(Store);
    store.commit(SOFTLINE_FEATURE_TRANSLATION, TranslationStore.mutations.add, {
      module: 'inventur',
      language: 'de',
      translations: de,
    });
    store.commit(SOFTLINE_FEATURE_APPLICATIONS, ApplicationStore.mutations.add, {
      name: '#INVENTUR.APP',
      description: '#INVENTUR.APP_DESC',
      icon: 'fa-regular fa-warehouse-full',
      route: '/inventur',
      permission: SOFTLINE_PERMISSION_INVENTUR,
      group: getModuleGroupByName('Lager'),
    });
  }),
];

export function provideInventurModule() {
  return [
    provideSoftAppsModule(
      {
        name: 'inventur',
        title: '#INVENTUR.APP',
        description: '#INVENTUR.APP_DESC',
        icon: 'fa-regular fa-warehouse-full',
        route: '/inventur',
        permission: SOFTLINE_PERMISSION_INVENTUR,
        group: getModuleGroupByName('Lager'),
      },
      withSoftAppsModuleRoutes({ app: inventurRoutes }),
      withLazySoftAppsModuleTranslation({
        eager: { de: deTitles },
        lazy: { de: () => import('../i18n/de.json') },
      }),
      withSoftAppsModuleInfo({
        library: '@softapps/lager/inventur',
        description: 'Inventur im Lager erfassen.',
      })
    ),
  ];
}
